import { gql } from "@/__generated__/gql";

export const DESTROY_INVITE_MUTATION = gql(`
  mutation DestroyInvite(
    $dashInviteId: ID!
  ) {
    destroyDashInviteMutation(input: {
      dashInviteId: $dashInviteId
    }) {
      errors {
        title
        message
      }
    }
  }
`);
